import {static_download_url} from "./global";
export default function setFavIcon(id) {
    let headTitle = document.querySelector("head");
    let setFavicon = document.createElement('link');
    setFavicon.setAttribute("rel", "shortcut icon");
    setFavicon.setAttribute("id", "fav");
    setFavicon.setAttribute("href", static_download_url + id);
    headTitle.appendChild(setFavicon);
}